// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3310488360": "Put the document into the mini program",
  "4018638528": "Scan the QR code to experience in WeChat",
  "d835ee6e91": "The file has been saved <a target=\"_blank\" href=\"//plus.wps.cn/view/media/p/{0}\" style=\"margin-left:10px;color:#417ff9\">View</a>",
  "a83b7c3d4d": "Move file successfully",
  "ded158d9dc": "File sharing has stopped",
  "11377326ac": "Please log in and try again",
  "321495498a": "This file does not support online preview, please download and view",
  "6728034eac": "Not a member of this company",
  "c1c0c3ef49": "Server error, please try again later",
  "94bd113e7c": "The file is damaged, please download and view",
  "e242d9844d": "The file format does not support online playback, please download and view",
  "7703961444": "Transcoding task timeout",
  "85d6dfb01c": "The duration of online audio and video playback rights has been used up, please download and view",
  "aa35fa807c": "Online audio and video playback for this company has been disabled, please contact customer service",
  "4c5c817619": "The author has deleted the file",
  "b8b1ab19a3": "Loading timeout, please try again later",
  "69570a01ee": "The author has stopped sharing the file",
  "ce6559062c": "File transcoding in progress... #{percent}%",
  "05bd98be76": "The sharing link has been closed",
  "c48dea50b2": "You do not have sufficient permissions for this operation",
  "780dc2da0a": "The file may contain prohibited content and access has been stopped",
  "bdeb76266c": "You do not have permission to download this file",
  "f99e7e8772": "This file format does not support downloading",
  "c99e7e8772": "The file is being previewed and converted, please try again later",
  "f996285100": "Play",
  "ed208c3846": "Replay",
  "c96a46727b": "Pause",
  "021ad16252": "Mute",
  "c5042be9e1": "Unmute",
  "aaee2e3006": "Fullscreen",
  "c1e237fdf1": "Exit fullscreen",
  "f1e2762445": "WPS Office",
  "2fd888fd9a": "Feedback to restore access",
  "800bee819a": "File sharing has stopped",
  "bc599ee5cd": "Feedback to restore sharing",
  "8fe1ecec60": "Download to local for viewing",
  "39a641bdc3": "Appeal submitted",
  "aed856a076": "The review is expected to be completed within 48 hours, please be patient",
  "025e60d871": "Enter WPS Office",
  "e385ada474": "File unsealing failed",
  "21805326f1": "The file may contain prohibited content, you can appeal again",
  "a20c3cecc5": "Appeal again",
  "06bff8a305": "Content cannot exceed 50 characters",
  "188c4f96ac": "Please provide the reason for the appeal",
  "fba51b188e": "Please provide a detailed description of the reason for the appeal",
  "919c36e310": "Video",
  "46680e2228": "File transcoding in progress...",
  "3d86d5e41b": "File transcoding...{0}% complete",
  "6fb2ee95a6": "Getting file...",
  "447ee65591": "WPS Document",
  "6c4746f45e": "WPS Document",
  "c8ccb36124": "Close",
  "060897215f": "Put the document into the mini program",
  "d488af2c8e": "Scan the QR code with WeChat to experience",
  "92861a3b7f": " Updated on ",
  "122ce7bbe9": "Share",
  "8742930fad": "Login",
  "265b2730bd": "Share",
  "40ad48e2e6": "Send to phone",
  "de36f56297": "Save as",
  "88a5eec7a5": "Download",
  "e42de3af08": "Back to homepage",
  "bb898f8c35": "Report file",
  "ff71e4f8a2": "Open with local application",
  "cd8cf2f471": "Non-enterprise audio and video files do not support online playback, please download and view",
  "9cae53c65a": "Server error, please try again later",
  "a670f3c26a": "The enterprise administrator has disabled the current operation",
  "4cbad45623": "Download",
  "9928443135": "Share",
  "e4f4b9a34d": "Save as",
  "b33f514a94": "Help and feedback",
  "bb4e26ff65": "Report file",
  "b8ed5c2de7": "Save and open",
  "e453958fe2": "Server error, please try again later",
  "79be6d4e4c": "Video",
  "0354b7ed16": "File location:",
  "137c5f6d85": " Updated on ",
  "d1674c594a": "Share",
  "6a2244a811": "Login",
  "4ec31fbe91": "Open with WPS",
  "b30f2ea44b": "WPS Document homepage",
  "3314fc385b": "File",
  "0686b09373": "{0} starred",
  "18eb6b5d58": "Cancel",
  "8a2a385103": "Modification successful",
  "4710fe77f2": "Modification failed",
  "cc0040f6e7": "Only the document owner can rename it",
  "fb603598cc": "Set as starred document, can be accessed quickly",
  "b6e981a032": "View",
  "bfa2986eb3": "Cancel starred document",
  "cb5f342bef": "Failed to {0} starred document",
  "0482a30b20": "Set as",
  "d1a3a7b120": "WPS Document",
  "2314ce6081": "The author has set specific access, please contact",
  "241c63f81a": "\n          Or log in with an account that has permission\n        ",
  "b573db113b": "The author has set access for enterprise members, please contact",
  "12069886e3": "Current logged in account {0}",
  "ced44fd785": "The application will be processed within 30 minutes, please refresh to view later",
  "a8c1a910b2": "Apply to restore access",
  "d8ffb18522": "Download",
  "6e4e2132b7": "Login",
  "71737deac3": "Enter WPS Document",
  "65680083e0": "Authenticate now",
  "dbc00698ae": "No access permission",
  "0c01094048": "File sharing has stopped",
  "8af9862a91": "File has been deleted",
  "4d74f721f5": "File does not exist",
  "1a9e17476b": "File access has been stopped",
  "6667a5fc14": "Application to restore access has been submitted",
  "fdb37ade7f": "WPS Office · Efficient office together",
  "dc8e5b3b97": "Server error, please try again later",
  "11373c971b": "Contact customer service",
  "1b310928e3": "After purchase, authentication by enterprise is required for playback\n      ",
  "d4c9ed35b7": "Preview conversion in progress",
  "5007152f7d": "Apply to upgrade package",
  "7ae4470de8": "Upgrade package",
  "5a50e52115": "Purchase {0}, 【Audio and video playback duration】 entitlement can be used without time limit",
  "cdc5268c10": "Upgrade package can preview audio and video online, saving download waiting time",
  "0e76e21514": "Reason for feedback",
  "c28bff886a": " (Please enter 5-50 characters)",
  "bfa366d4df": "Please provide a detailed description of the feedback reason to expedite the feedback process",
  "8c30b9472d": "Submit",
  "309ec43078": "Feedback",
  "6479ccd94a": "Feedback Reason",
  "fc4e48a17a": " (Please enter 5-50 characters)",
  "58f69ca425": "Please provide a detailed description of the feedback reason, which can expedite the feedback process",
  "7b5fb662cc": "Submit",
  "2152682d5d": "This file does not support online preview, please download and view it",
  "887322b897": "Server error, please try again later",
  "27ef615a27": "<p>Please contact the author</p><p>Current logged-in account: {0}</p>",
  "5306bedfb4": "Contact the administrator to upgrade to the enterprise package and enable the rights to play audio and video online.",
  "39dba15903": "The current enterprise package does not include the right to play audio and video online. For purchase, please consult: 17607563040",
  "c6110c9a54": "Audio and video files from other companies are not supported for online playback. Please download and view",
  "4db4c3dc63": "Contact the administrator to complete the enterprise certification to use the right to play audio and video online",
  "a2368c2d06": "The enterprise is not certified. Once certified, you can use the right to play audio and video online",
  "8bd57619ed": "This file does not support online preview, please download and view it",
  "a0f065de59": "Server error, please try again later",
  "6c9f11f229": "<p>Please contact the author</p><p>Current login account {0}</p>",
  "aaad91aec8": "Contact the administrator to upgrade the enterprise package and open the rights to play audio and video online",
  "f1bd446446": "The current enterprise package does not include the rights to play audio and video online. For purchase, please consult: 17607563040",
  "22f2a07b81": "Audio and video files from other companies are not supported for online playback. Please download and view.",
  "1cd5c90386": "Contact the administrator to complete the enterprise certification and gain access to the rights to play audio and video online.",
  "a04123abbc": "Enterprise not verified, please proceed with enterprise verification (free)<br/>Verification will allow you to play",
  "fdd678fd78": "Contact Customer Service",
  "471041043d": "Customer Service QQ Number for \"Kingsoft Document\"",
  "89a75c2d8d": "Copy group number",
  "1894fcb0c1": "WeChat group for feedback and communication on 'Kingsoft Document'",
  "081814f2bd": "Save image, scan QR code to join the group",
  "26b115245d": "Copy successful",
  "f96075a6c8": "The current sharing link is invalid",
  "d22b2a0380": "The problem has been reported",
  "90446028cc": "Click to provide feedback on the problem",
  "4ca22157a0": "Appeal submitted successfully",
  "1d3c1de9d7": "Failed to submit appeal",
  "4e0e975d62": "Download not supported",
  "04edf8028f": "File name does not exist",
  "1ee5f66661": "Submit",
  "c2c0c5ef78": "File exception, please check and upload again"
}